import countries from "../constants/countries";

export const EMAIL_FIELD = {
  label: "Email address",
  type: "email",
  name: "email",
  placeholder: "Business Email Address",
  className: "sisp-input",
  key: "email",
  pattern: "[^+!#%&+]+",
  minLength: 3,
  maxLength: 100,
  errortext: "Please enter a Business valid email address",
};
export const FIRST_NAME_FIELD = {
  label: "First name",
  name: "firstName",
  placeholder: "First name",
  className: "sisp-input sisp-input-half",
  key: "firstName",
  pattern: "^([\u0080-\u07FF\u0800-\uFFFFa-zA-Z]+).*$",
  minLength: 1,
  maxLength: 30,
  errortext: "Please enter a valid First name",
};
export const LAST_NAME_FIELD = {
  label: "Last name",
  name: "lastName",
  placeholder: "Last name",
  className: "sisp-input sisp-input-half",
  key: "lastName",
  pattern: "^([\u0080-\u07FF\u0800-\uFFFFa-zA-Z]+).*$",
  minLength: 1,
  maxLength: 30,
  errortext: "Please enter a valid Last name",
};
export const PHONE_NAME_FIELD = {
  label: "Phone Number",
  type: "phone",
  name: "phone",
  placeholder: " ",
  className: "sisp-input",
  key: "phone",
  minLength: 1,
  maxLength: 12,
  errortext: "Please enter a valid Phone Number",
};

export const ORG_NAME_FIELD = {
  type: "org-name",
  label: "Organization name",
  name: "name",
  placeholder: " ",
  className: "sisp-input",
  key: "name",
  pattern: "^[^@?~`\\^\\|]*$",
  minLength: 3,
  maxLength: 100,
  errortext: "Organization name must contain atleast 3 characters and cannot contain special characters (?, ~, `, ^, |).",
};
export const GADDRESS_FIELD = {
  label: "Address",
  key: "gAddress",
  type: "gAddress",
  pattern: "^[^@?~`\\^\\|]*$",
  minLength: 2,
  maxLength: 100,
  errortext: "Address must be at least 2 characters and cannot contain special characters (?, ~, `, ^, |).",
};

export const COUNTRY_FIELD = {
  label: "Country",
  name: "countryCode",
  placeholder: " ",
  className: "sisp-input ",
  key: "countryCode",
  type: "select",
  options: countries,
  pattern: "^[^@?~`\\^\\|]*$",
  minLength: 2,
  maxLength: 50,
  errortext: "Please select a valid Country.",
};

export const STATE_FIELD = {
  label: "State/Province",
  name: "state",
  placeholder: " ",
  className: "sisp-input",
  key: "state",
  type: "select",
  options: [],
  pattern: "^[^@?~`\\^\\|]*$",
  minLength: 2,
  maxLength: 50,
  errortext: "State/Province must be at least 2 characters and cannot contain special characters (?, ~, `, ^, |).",
};

export const CITY_FIELD = {
  type: "select",
  label: "City",
  name: "city",
  placeholder: " ",
  options: [],
  className: "sisp-input sisp-input-half",
  key: "city",
  pattern: "^[^@?~`\\^\\|]*$",
  minLength: 2,
  maxLength: 30,
  errortext: "City must be at least 2 characters and cannot contain special characters (?, ~, `, ^, |).",
};

export const ZIP_FIELD = {
  type: "select",
  label: "Zip code/Postal code",
  name: "postalCode",
  apifieldname: "postal_code",
  placeholder: " ",
  options: [],
  className: "sisp-input sisp-input-half",
  key: "postalCode",
  pattern: "^[^@?~`\\^\\|]*$",
  minLength: 2,
  maxLength: 10,
  errortext: "Postal Code must be at least 2 characters and cannot contain special characters (?, ~, `, ^, |).",
};

export const COUNTY_FIELD = {
  type: "select",
  label: "County",
  name: "county",
  placeholder: " ",
  options: [],
  className: "sisp-input sisp-input-half",
  key: "county",
  // minLength: 3,
  maxLength: 30,
  required: false,
};

export const ADDRESS_FIELD_1 = {
  type: "address",
  label: "Address line 1",
  key: "line1",
  name: "addressLine1",
  placeholder: " ",
  className: "sisp-input sisp-input-half",
  pattern: "^[^@?~`\\^\\|]*$",
  minLength: 2,
  maxLength: 75,
  errortext: "Address line 1 must be at least 2 characters and cannot contain special characters (?, ~, `, ^, |).",
};

export const ADDRESS_FIELD_2 = {
  type: "address",
  label: "Address line 2",
  key: "line2",
  name: "addressLine2",
  placeholder: " ",
  className: "sisp-input sisp-input-half",
  pattern: "^[^@?~`\\^\\|]*$",
  minLength: 2,
  maxLength: 75,
  required: false,
  errortext: "Address line 2 must be at least 2 characters and cannot contain special characters (?, ~, `, ^, |).",
};

export const ADDRESS_FIELD_3 = {
  type: "address",
  label: "Address line 3",
  key: "line3",
  name: "addressLine3",
  placeholder: " ",
  className: "sisp-input sisp-input-half",
  pattern: "^[^@?~`\\^\\|]*$",
  minLength: 2,
  maxLength: 75,
  required: false,
  errortext: "Address line 3 must be at least 2 characters and cannot contain special characters (?, ~, `, ^, |).",
};

export const OrganizationFields = [
  ADDRESS_FIELD_1,
  ADDRESS_FIELD_2,
  ADDRESS_FIELD_3,
  COUNTRY_FIELD,
  STATE_FIELD,
  CITY_FIELD,
  ZIP_FIELD,
  COUNTY_FIELD
  // {
  //   label: 'Address line 4',
  //   key: 'line4',
  //   name: 'addressLine4',
  //   placeholder: ' ',
  //   className: 'sisp-input',
  //   minLength: 0,
  //   maxLength: 75,
  //   required: false,
  // },
];

export const STEPPER_FORM = [
  {
    key: "primaryUser",
    name: "primaryUser",
    placeholder: " ",
    className: "sisp-input",
    title: "Register admin user",
    fields: [EMAIL_FIELD, FIRST_NAME_FIELD, LAST_NAME_FIELD, PHONE_NAME_FIELD],
  },
  {
    key: "customer",
    name: "customer",
    title: "Register organization",
    fields: [ORG_NAME_FIELD, GADDRESS_FIELD, ...OrganizationFields],
  },
];

export default STEPPER_FORM;
